<ng-container *ngIf="selectedItem$ | async as selectedItem; else buttonWithoutSelection;">
	<div (click)="onSelectionClickedAsync($event)">
		<calao-customer-selector-popover-item [item]="selectedItem"></calao-customer-selector-popover-item>
		<ion-icon name="caret-down-outline" color="medium"></ion-icon>
	</div>
</ng-container>

<ng-template #buttonWithoutSelection>
	<ion-button (click)="onSelectionClickedAsync($event)">
		Sélectionner un client
	</ion-button>
</ng-template>